import GMaps from 'gmaps';

(function (window, document, $, app) {
	// console.log(app.maps_data);
	// console.log('js');

	const initContactMap = function initContactMap() {
		const mapElement = document.querySelector('#yshift-contact-map');

		if (!mapElement) {
			return;
		}

		// Replace style
		const styles = [
			{
				featureType: 'all',
				elementType: 'labels.text.fill',
				stylers: [
					{
						saturation: 36,
					},
					{
						color: '#000000',
					},
					{
						lightness: 40,
					},
				],
			},
			{
				featureType: 'all',
				elementType: 'labels.text.stroke',
				stylers: [
					{
						visibility: 'on',
					},
					{
						color: '#000000',
					},
					{
						lightness: 16,
					},
				],
			},
			{
				"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 20
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					},
					{
						"weight": 1.2
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 20
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 21
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 29
					},
					{
						"weight": 0.2
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 18
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 16
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					}
				]
			}
		];

		app.maps = app.maps || {};

		app.maps.contactMap = new GMaps({
			disableDefaultUI: false,
			el: mapElement,
			lat: app.maps_data.lat,
			lng: app.maps_data.lng,
			scrollwheel: false,
			streetViewControl: false,
			zoom: 17,
		});

		app.maps.contactMap.addMarker({
			lat: app.maps_data.lat,
			lng: app.maps_data.lng,
			icon: {
				url: app.maps_data.icon,
				scaledSize: new google.maps.Size(33, 40),
			},
			optimized: false,
		});

		app.maps.contactMap.addStyle({
			styledMapName: 'Contact page map',
			styles,
			mapTypeId: 'contact_page_map_style',
		});

		app.maps.contactMap.setStyle('contact_page_map_style');
	};

	$(() => {
		initContactMap();
	});

})(window, document, jQuery, Yco);




// WEBPACK FOOTER //
// ./assets/scripts/maps.js